
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","viewBox":"0 0 26 21","fill":"#47AEA6","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"6","width":"26","height":"4","rx":"2","transform":"rotate(45 6 0)"}}),_c('rect',{attrs:{"x":"3","y":"18.385","width":"26","height":"4","rx":"2","transform":"rotate(-45 3 18.385)"}})])
          )
        }
      }
    